module.exports = __webpack_public_path__ + "static/img/biobank-1.d8432969a5ddefe4018644162dc0ef45.png";